import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';
var ls = new SecureLS({ encodingType: 'aes' }); // used for encrypting our local storage so data is not viewable locally
// import the auto exporter
// import modules from './modules
// can't use auto-importer right now, namespacing issue.
// commenting out for now cuz it's amazing but I need to continue working

import auth from './modules/store.auth.js';
import credit from './modules/store.credit.js';
import creditcard from './modules/store.creditcard.js';
import invoices from './modules/store.invoices.js';
import tickets from './modules/store.tickets.js';
import user from './modules/store.user.js';
import vm from './modules/store.vm.js';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    credit,
    creditcard,
    invoices,
    tickets,
    user,
    vm
  },
  mutations: {
  },
  actions: {
    RESET({commit}) {
      // resets state of all the modules
      // Object.keys(modules).forEach(moduleName => {
      //   commit(`${moduleName}/RESET`);
      // })
      commit('auth/RESET');
      commit('credit/RESET');
      commit('creditcard/RESET');
      commit('invoices/RESET');
      commit('tickets/RESET');
      commit('user/RESET');
      commit('vm/RESET');
    }
  },
  plugins: [
    createPersistedState({
      key: 'BitAccel',
      paths: ['auth', 'credit', 'creditcard', 'invoices', 'tickets', 'user', 'vm'],
      storage: { // use SecureLS package to encrypt data
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      }
    }),
  ],
  strict: true
})
